/**
 * A minimal <video> element in the SSR HTML so Googlebot can confirm
 * the video exists without executing JavaScript. Visually invisible.
 * The interactive player (StreamVideoPlayer) handles playback client-side.
 */
type SsrVideoElementProps = {
  src: string | undefined;
  poster: string | undefined;
};

const SsrVideoElement = ({
  src,
  poster,
}: SsrVideoElementProps): JSX.Element | null => {
  if (!src) return null;

  return (
    // SEO-only crawl hint for Googlebot; interactive player handles playback.
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      src={src}
      poster={poster || ''}
      preload="none"
      playsInline
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        overflow: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
      }}
    />
  );
};

export default SsrVideoElement;
